<template>
    <ies-form-field :field="field">
       <v-layout row-sm column>
            <v-row>
				<v-col sm="12" class="flex-row">
					<input type="hidden" :name="field.fieldName" :value="field.value">

					<v-col lg="4">
						<label for="latitude">Latitude</label>
						<v-text-field hide-details
							name="latitude" 
							v-model="map.latitude" v-on:keyup="updateField()"
							:required="this.field.required" 
							:disabled="this.field.disabled"
						></v-text-field>
					</v-col>
					<v-col lg="4">
						<label for="longitude">Longitude</label>
						<v-text-field hide-details
							name="longitude"
							v-model="map.longitude" v-on:keyup="updateField()"
							:required="this.field.required"
							:disabled="this.field.disabled"
						></v-text-field>
					</v-col>
					<v-col lg="4">
						<label for="zoom">Zoom</label>
						<v-text-field hide-details
							name="zoom"
							v-model="map.zoom" v-on:keyup="updateField()"
							:required="this.field.required"
							:disabled="this.field.disabled"
						></v-text-field>
					</v-col>
                </v-col>
            </v-row>
        </v-layout>
    </ies-form-field>
</template>

<script>
export default {
    name: 'ies-google-map',
    props: ['field'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
        return {
            map: { 'latitude': 0.0, 'longitude': 0.0, 'zoom': 1 },
        }
    },
    methods: {
		updateViewFromModel: function(){
			var mapSettings = this.field.value.split(",");
			this.map.latitude = mapSettings[0];
			this.map.longitude = mapSettings[1];
			this.map.zoom = mapSettings[2];
		},

		updateModelFromView: function(newValue) {
			this.field.value = this.map.latitude + "," + this.map.longitude + "," + this.map.zoom + ",m";
		}
	},
	
	created:function() {
		this.updateViewFromModel();
	},

	watch: {
		'map.latitude': 	function(){ this.updateModelFromView(); },
		'map.longitude': 	function(){ this.updateModelFromView(); },
		'map.zoom': 		function(){ this.updateModelFromView(); },
	}	
}
</script>
